module.exports = __webpack_public_path__ + "static/media/Furniture.4828fedc.png";